import { useMemo } from "react"
import { useNavigate } from "react-router-dom"

import { getPermissionValueAtPath } from "../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../constants/routes.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import type { SubjectType } from "../types/esign.types.ts"

export const SEND_FOR_SIGNATURE_PERMISSION =
  "esign.signatures.document_send_for_signature" as const

export interface SignatureSubject {
  type: SubjectType
  id: string
}

export type OpenSignatureWizard = (subject?: SignatureSubject) => void

/** Opens the wizard on the record, or `null` for someone who may not send. */
export const useSendForSignature = (
  leadId: string | null | undefined
): OpenSignatureWizard | null => {
  const navigate = useNavigate()
  const allowed = useAppSelector((state) =>
    getPermissionValueAtPath(
      state.auth?.permissions?.codes,
      SEND_FOR_SIGNATURE_PERMISSION
    )
  )

  return useMemo(
    () =>
      allowed && leadId
        ? (subject) =>
            navigate(
              RoutesPaths.esign.newEnvelope({
                lead: leadId,
                subject_type: subject?.type,
                subject_id: subject?.id
              })
            )
        : null,
    [allowed, leadId, navigate]
  )
}
